import {
  array,
  boolean,
  Codec,
  GetInterface,
  number,
  string,
} from "purify-ts/Codec"
import { dateCodec } from "../utils/dateValidationMsg"

export const SearchParameters = Codec.interface({
  areaType: string,
  bruksklasse: number,
  fylkesNummer: array(number),
  kommuneNummer: array(number),
  date: dateCodec("nb_NO"),
  vegsystemReferanse: string,
  spraak: string,
  publisering: boolean,
  V4: boolean,
})

export type SearchParameters = GetInterface<typeof SearchParameters>
